module.exports = __webpack_public_path__ + "static/media/Especialidades.ff6fe6f2.svg";